import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import TnbOrder from "./pages/TnbOrder";
import OrderSuccess from "./pages/OrderSuccess";
import OrderCancel from "./pages/OrderCancel";
import TnbStaff from "./pages/TnbStaff";
import { THEME } from "./lib/theme";
import "./App.css";

export default function App() {
  // Apply theme once at boot. Change /app/frontend/src/lib/theme.js to swap.
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", THEME);
  }, []);

  return (
    <div className="min-h-screen bg-app text-app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/tnb-order" replace />} />
          <Route path="/tnb-order" element={<TnbOrder />} />
          <Route path="/tnb-order/success" element={<OrderSuccess />} />
          <Route path="/tnb-order/cancel" element={<OrderCancel />} />
          <Route path="/tnb-staff" element={<TnbStaff />} />
          <Route path="*" element={<Navigate to="/tnb-order" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors closeButton />
    </div>
  );
}
